import { useQuery } from 'react-query'
import { getContent } from 'src/services/contentful'

export const useFetchContent = () => {
	return useQuery('getContent', () => getContent(), {
		retry: 3,
		staleTime: 0,
		refetchOnWindowFocus: false,
		refetchInterval: 0
	})
}
